const messages = {
  title: "Marketinški pristanci",
  required: "Obavezno",
  answered: "✓ Odgovoreno",
  read: "Pročitano",
  notRead: "Nije pročitano",
  alreadyAnswered: "Već odgovoreno",
  requiredQuestionsMustBeAccepted:
    "Potrebno je prihvatiti još {count} obaveznih pitanja",
  pleaseAnswerQuestions: "Molimo odgovorite na sljedeća pitanja:",
  iAccept: "Prihvaćam",
  scrollToUnlock: "Za otključavanje pomaknite se do kraja",
  fieldRequired: "Ovo polje je obavezno",
  scrollToContinue: "↓ Za nastavak pomaknite se do kraja",
  saving: "Spremanje...",
  saveConsents: "Spremi pristanke",
  allRequiredAccepted: "✓ Sva obavezna pitanja prihvaćena",
  requiredConsentsCompleted:
    "{completed}/{total} obaveznih pristanaka ispunjeno",
  selectConsentToView:
    "Odaberite pristanak s popisa za prikaz sadržaja",
  readAllContentFirst: "Prvo pročitajte sav sadržaj: {names}",
  acceptAllRequiredIn:
    "Prihvatite sva obavezna pitanja u: {names}",
  acceptAllBeforeSaving:
    "Prije spremanja prihvatite sva obavezna pitanja.",
  failedToSave: "Pristanci se nisu mogli spremiti. Pokušajte ponovno.",
  errorSaving:
    "Došlo je do pogreške pri spremanju pristanaka. Pokušajte ponovno.",
  failedToLoad: "Pristanci se nisu mogli učitati. Osvježite stranicu.",
  viewPdf: "Prikaži PDF",
  requiredConsentTitle: "Obavezni pristanak",
  acceptAndContinue: "Prihvati i nastavi",
};

export default {
  messages,
};
